// @ts-nocheck
import { styled, css } from 'styled-components'
import type { Breakpoint } from '../breakpoints'
import { BREAKPOINTS } from '../breakpoints'
import type { DSGridSpacing } from '../styles/tokens/grid-spacing-styles'

const StyledSpacer = styled.div<{ $size: DSGridSpacing; $breakpoints?: SpacerBreakpoints }>`
  flex: none; // ensures if parent is flexbox, it doesn't grow/shrink

  &.horizontal {
    width: ${(props) => `var(--grid-${props.$size});`};
  }

  &.vertical {
    width: 100%;
    height: ${(props) => `var(--grid-${props.$size});`};
  }

  ${(props) =>
    props.$breakpoints &&
    Object.entries(props.$breakpoints).map(
      ([breakpoint, size]) => css`
        @media (max-width: ${BREAKPOINTS[breakpoint]}) {
          &.horizontal {
            width: var(--grid-${size});
          }

          &.vertical {
            width: 100%;
            height: var(--grid-${size});
          }
        }
      `,
    )}
`

export type SpacerBreakpoints = {
  [key in Breakpoint]?: DSGridSpacing
}

interface SpacerProps {
  size: DSGridSpacing
  direction: 'horizontal' | 'vertical'
  breakAt?: SpacerBreakpoints
}

export function DSSpacer({ size, direction, breakAt }: SpacerProps) {
  return <StyledSpacer $breakpoints={breakAt} $size={size} className={direction} />
}
